import { CoinGeckoTokenInfo } from '@/utils';
import { useMemo } from 'react';

export const useTokenImagesMap = (coinGeckoTokensInfo: CoinGeckoTokenInfo | null | undefined) => {
  return useMemo(() => {
    if (!coinGeckoTokensInfo?.data) return {};
    return coinGeckoTokensInfo.data.reduce((acc: Record<string, string>, token) => {
      if (token?.attributes?.symbol && token?.attributes?.image_url) {
        acc[token.attributes.symbol] = token.attributes.image_url;
      }
      return acc;
    }, {});
  }, [coinGeckoTokensInfo]);
};
